const socketType = {
    Customer: 0,
    User: 1,
    Account: 2,
    MasterAdmin: 3
}

export default socketType